<header>
    <div class="layout-header-full fixed-top">
        <app-header-bare></app-header-bare>
    </div>
</header>

<div class="splash-bg-container">
    <div class="splash-bg">
        <div class="splash-img"></div>
        <div class="splash-img-overlay"></div>
    </div>
</div>
<div class="container-fluid layout-container">
    <div class="row">
        <div class="col">
            <div class="splash-body container">
                <div class="splash-card mx-auto">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>

<q-footer [ver]="version" [bussAppUrl]="businessAppUrl" [isLight]="true">
</q-footer>
